import clsx from 'clsx'
import { isFrsRoute } from '../../Utils/frs-helpers'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import SelectField from '../Shared/SelectField'
import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'
import { VehicleIcon } from './VehicleIcon'
import Vehicles from './Vehicles'
import { getMultipleVehicleSelectedCount } from '../../Utils/vehicles'
import { useTranslation } from 'react-i18next'
import { TrackMultipleVehicles } from '../../Utils/tracking'
import { useRoutes } from '../../Hooks/routes/useRoutes'
import { useVehicles } from '../../Hooks/vehicles/useVehicles'

export default function VehiclesSelector() {
  const { dispatch } = useTravelSearchContext()
  const { activeField, closeIfActive, toggleField } = useActiveSelectField()
  const { t } = useTranslation()
  const { isRoutesLoading, selectedRoute } = useRoutes()
  const { selectedVehicle, vehicleApiData, isVehiclesLoading } = useVehicles()

  return (
    <div
      className={clsx(
        'ts-h-[58px] ts-w-full ts-justify-center md:ts-col-span-6 ts-col-span-12 lg:ts-col-auto ts-box-border ts-border lg:ts-border-r-0 ts-border-solid ts-border-cvi-grey-grey200',
        isFrsRoute(selectedRoute?.routeCode ?? '') && 'ts-hidden'
      )}
    >
      <SelectField
        dataAttrList={[
          { name: 'selected-vehicle', value: `${selectedVehicle?.code}` },
          { name: 'selected-trailer', value: `${selectedVehicle?.trailer?.code}` },
        ]}
        disabled={
          vehicleApiData?.vehicleTypes?.reduce((count, current) => count + current.code.length, 0) === 1 ||
          (vehicleApiData?.vehicleTypes?.reduce((count, current) => count + current.code.length, 0) === 0 &&
            selectedVehicle.code === 'NCAR')
        }
        title={t('VEHICLE')}
        isLoading={isRoutesLoading || isVehiclesLoading}
        isOpen={activeField === ActiveSelectField.VEHICLE}
        fieldName="vehicle"
        value={
          selectedVehicle.trailer
            ? `${getMultipleVehicleSelectedCount(selectedVehicle?.count)}${t(`VEHICLE-NAME-${selectedVehicle?.code}`)} + ${getMultipleVehicleSelectedCount(selectedVehicle?.count)} ${t(
                `TRAILER-NAME-${selectedVehicle?.trailer?.code}`
              )}`
            : `${getMultipleVehicleSelectedCount(selectedVehicle?.count)}${t(`VEHICLE-NAME-${selectedVehicle?.code}`)}`
        }
        icon={selectedVehicle?.code && <VehicleIcon code={selectedVehicle?.code} size="md" />}
        visibleRows={selectedVehicle && selectedVehicle.trailer ? 2 : 1}
        onClick={(clickedOutside: boolean) => {
          !isRoutesLoading && !isVehiclesLoading && toggleField(ActiveSelectField.VEHICLE, clickedOutside)
        }}
        onClose={() => {
          closeIfActive(ActiveSelectField.VEHICLE)
        }}
      >
        <Vehicles
          dataAttrList={[
            { name: 'selected-vehicle', value: `${selectedVehicle?.code}` },
            { name: 'selected-trailer', value: `${selectedVehicle?.trailer?.code}` },
          ]}
          isLoading={isRoutesLoading || isVehiclesLoading}
          onCheckMultipleVehicle={(multipleVehicleChecked: boolean) => {
            if (!multipleVehicleChecked && selectedVehicle) {
              // Reset vehicle count
              dispatch({ type: 'SET_VEHICLE', vehicle: { ...selectedVehicle, count: 1 } })
            }
            dispatch({
              type: 'SET_MULTIPLE_VEHICLES_CHECKED',
              checked: multipleVehicleChecked,
            })
            TrackMultipleVehicles(multipleVehicleChecked)
          }}
          onFooterClick={() => closeIfActive(ActiveSelectField.VEHICLE)}
        />
      </SelectField>
    </div>
  )
}
